import '../sass/pages/login.scss';

require('bootstrap');
require('../webroot/assets/global/plugins/jquery-validation/js/jquery.validate.min.js');
require('../webroot/assets/global/plugins/jquery-validation/js/additional-methods.min.js');

require('../webroot/assets/global/scripts/app.js');
require('../webroot/assets/pages/scripts/login.js');
